// extracted by mini-css-extract-plugin
module.exports = {"answer":"Answer_answer__1FgaY","answerPrefix":"Answer_answerPrefix__2RtJL","selected":"Answer_selected__10jnJ"};